import React, { ReactElement } from "react";
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import AppButton from "@/features/line-sheet-sets/app-button";
import { buyerRequestsMutationApi } from "@/shared/api/buyer-requests/mutation";
import useIdentity from "@/features/ui/hooks/use-identity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function MarkupRequestModal({ isOpen, onClose }: Props) {
  const { tTitle, tSentence } = useI18nHelper();
  const identity = useIdentity();
  const [brandId, setBrandId] = React.useState<string>("");
  const { info } = useAppToasts({ id: "GLOBAL" });

  const handleClose = () => {
    setBrandId("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent borderRadius={"8px"} overflow={"hidden"}>
        <ModalHeader background={"#F7F9FA"} padding={"12px 16px"}>
          <Text textStyle={"body-md-bold"} color={"#444444"}>
            {tTitle("request_markup_info_modal_title")}
          </Text>
        </ModalHeader>
        <ModalBody display="flex" flexDirection={"column"} gap={"24px"}>
          <Text textStyle={"body-md-regular"} color={"#6F6F6C"}>
            {tSentence("request_markup_info_modal_description")}
          </Text>
          <FormControl>
            <FormLabel color={"#6F6F6C"}>
              <Text textStyle={"body-sm-regular"}>
                {tTitle("request_markup_info_modal_label")}
              </Text>
            </FormLabel>
            <Input
              height={"28px"}
              placeholder={tSentence("request_markup_info_modal_placeholder")}
              fontSize={"13px"}
              fontWeight={"400"}
              padding={"4px 8px"}
              value={brandId}
              onChange={(e) => setBrandId(e.target.value)}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter display={"flex"} justifyContent={"end"} gap={"12px"}>
          <AppButton variant={"normal"} onClick={handleClose}>
            <Text textStyle={"body-sm-bold"} color={"#444444"}>
              {tTitle("cancel")}
            </Text>
          </AppButton>
          <AppButton
            variant={"primary"}
            onClick={async () => {
              if (!identity?.company) {
                handleClose();
                return;
              }
              try {
                const res = await buyerRequestsMutationApi.addMarkupInfo(
                  identity.company.id,
                  {
                    brand_name: brandId,
                  }
                );

                if (res.status === 200) {
                  info(tSentence("request_brand_success"));
                }
                handleClose();
              } catch (e) {
                console.error(e);
              }
            }}
          >
            <Text textStyle={"body-sm-bold"} color={"#FFFFFF"}>
              {tTitle("request_brand_title_modal")}
            </Text>
          </AppButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
